import { DashboardType } from "@front/m19-api-client";
import { InjectionToken } from "@angular/core";

export const DASHBOARD_TYPE_360 = new InjectionToken<DashboardType>("DashboardType");
